// extracted by mini-css-extract-plugin
module.exports = {"stateName":"QINzC","totalSeats":"edAgR","seprator":"Flt4L","smallSize":"FwDhv"};